import { useClient, useMutation } from '@weenat/client'
import { useIntl } from '@weenat/wintl'
import useDisclosure from 'app/src/hooks/useDisclosure'
import useToasts from 'app/src/hooks/useToasts'
import Button from 'app/src/kit/Button'
import ConfirmationModal from 'app/src/kit/ConfirmationModal'
import AccountSection from 'app/src/me/AccountSection'
import { useUserContext } from 'app/userProvider'
import { isEmpty, isNil } from 'lodash-es'

const ChangePassword = () => {
  const { t } = useIntl()
  const client = useClient()
  const { addSuccessToast, addErrorToast } = useToasts()
  const { me } = useUserContext()

  const confirmResetModal = useDisclosure()

  const [sendResetPasswordEmail, sendResetPasswordEmailRequest] = useMutation(
    client.auth.resetPassword(),
    {
      onSuccess: () => {
        addSuccessToast(
          t('auth.reset_password_email_sent', {
            email: me.email
          })
        )
      },
      onError: (e) => {
        const [error] = e.nonFieldErrors || []
        if (!isNil(error)) {
          if (!isEmpty(t(`error_codes.${error.code}`))) {
            addErrorToast(t(`error_codes.${error.code}`))
          } else {
            addErrorToast(t('errors.unknown'))
          }
        }
      }
    }
  )

  return (
    <AccountSection title={t('models.account.fields.password.label', { capitalize: true })}>
      <Button onPress={confirmResetModal.open}>{t('actions.reset_password')}</Button>
      <ConfirmationModal
        isOpen={confirmResetModal.isOpen}
        onCancel={confirmResetModal.close}
        onConfirm={() => {
          sendResetPasswordEmail({ email: me.email })
          confirmResetModal.close()
        }}
        confirmButtonState={sendResetPasswordEmailRequest}
        confirmationMessage={t('auth.reset_password_dialog_message', { email: me.email })}
        title={t('actions.reset_password')}
      />
    </AccountSection>
  )
}

export default ChangePassword
